const angular = require('angular');

const OrderInformationService = require('./order-information.service.js');
const { orderInformationComponentDefinition } = require('./order-information.component');
const { orderInformationTipsComponentDefinition } = require('./order-information-tips.component');
const { orderInformationCountdownComponentDefinition } = require('./order-information-countdown.component');

angular.module('wowApp.shop')
    .service('OrderInformationService', OrderInformationService)
    .component('wowOrderInformation', orderInformationComponentDefinition)
    .component('wowOrderInformationTips', orderInformationTipsComponentDefinition)
    .component('wowOrderInformationCountdown', orderInformationCountdownComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/orderinformation/index.js